import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import Layout, { Card, Label, Spinner } from "../components/Layout";
import { Lightning, ArrowLeft, BookOpen } from "@phosphor-icons/react";

export default function HelpPage() {
  const { page } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/help/${page}`).then(({ data }) => { setData(data); setLoading(false); });
  }, [page]);

  if (loading) return <Layout title="Help"><Spinner /></Layout>;

  return (
    <Layout
      title={data.title}
      subtitle="Guida in linea"
      actions={<Link to="/faq" className="btn-ghost" data-testid="back-to-faq"><ArrowLeft size={14} className="inline mr-1" /> Torna alle FAQ</Link>}
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card className="lg:col-span-2">
          <Label>Descrizione</Label>
          <p className="text-sm leading-relaxed mt-2 text-zinc-700" data-testid="help-content">{data.content}</p>
        </Card>
        <Card className="ai-panel">
          <Lightning weight="fill" className="text-violet-600 mb-2" size={22} />
          <Label>Suggerimenti</Label>
          <ul className="text-sm space-y-2 mt-2" data-testid="help-tips">
            {(data.tips || []).map((t, i) => (
              <li key={i} className="flex items-start gap-2">
                <BookOpen size={14} className="text-violet-600 mt-0.5 flex-shrink-0" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </Layout>
  );
}
